module.exports = __webpack_public_path__ + "images/c704c644002c1af8312b3a8ac51476f3.png";


//////////////////
// WEBPACK FOOTER
// ./js/components/assets/man/3.png
// module id = 363
// module chunks = 0